export default {
  brandName: "Basetao Sheet",
  navHome: "Início",
  navGuide: "Guia Spreadsheet",
  navCategories: "Categorias",
  navFaq: "FAQ",
  navShoppingGuide: "Guia de compras",
  articleNotFound: "Artigo não encontrado",
  tocTitle: "Índice",
  backHome: "Voltar ao início",
  relatedTitle: "Recursos relacionados",
  authorName: "Equipe editorial da Basetao Sheet",
  authorRole: "Pesquisa de compras independente",
  articleFaqTitle: "Perguntas frequentes",
  ctaBasetao: "Basetao Spreadsheet",
  ctaBuyNow: "Comprar agora",
  languageLabel: "Idioma",
  footerTagline:
    "Um hub de recursos independente para pesquisa de Basetao Spreadsheet, categorias de produtos, guias e dicas práticas de compras na China.",
  footerNavTitle: "Explorar",
  footerCategoriesTitle: "Categorias",
  footerLegalTitle: "Legal",
  footerPrivacy: "Privacidade",
  footerTerms: "Termos",
  footerDisclaimer: "Aviso legal",
  footerAbout: "Sobre",
  footerContact: "Contato",
  footerDisclaimerText:
    "Este é um site informativo independente. Não somos afiliados nem o site oficial da Basetao. Todas as marcas pertencem aos seus respectivos donos. Disponibilidade, preços e taxas de envio podem mudar a qualquer momento.",
  footerCopyright: "Todos os direitos reservados.",
  footerMadeWith: "Recurso independente · Atualizado regularmente",
};